var _path, _g, _path2, _g2, _g3, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgotPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6587 64H10.7969C8.4979 64 6.63428 62.1363 6.63428 59.8373V29.1382C6.63428 26.8392 8.4979 24.9756 10.7969 24.9756H41.496C43.795 24.9756 45.6587 26.8392 45.6587 29.1382V64Z",
    fill: "#27312C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M41.4958 24.9756H36.2926C38.5916 24.9756 40.4552 26.8392 40.4552 29.1382V35.2252C40.4552 36.4153 39.7792 37.5033 38.7101 38.0261C33.4321 40.6071 29.7886 46.0323 29.7886 52.2926C29.7886 56.923 31.7822 61.0962 34.9558 64H45.6584V29.1382C45.6584 26.8392 43.7948 24.9756 41.4958 24.9756Z",
    fill: "#E8EDFB"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5083 13.6381V24.9756H17.9717V13.6381C17.9717 9.12337 21.6315 5.4635 26.1463 5.4635C30.6611 5.4635 34.3209 9.12337 34.3209 13.6381V24.9756H39.7843V13.6381C39.7844 6.106 33.6786 0 26.1464 0C18.6143 0 12.5083 6.106 12.5083 13.6381Z",
    fill: "#E9E9E9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5083 20.813H17.9717V24.9756H12.5083V20.813Z",
    fill: "#A5A5A5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3213 20.813H39.7847V24.9756H34.3213V20.813Z",
    fill: "#A5A5A5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6585 64C52.1244 64 57.3659 58.7584 57.3659 52.2926C57.3659 45.8268 52.1244 40.5852 45.6585 40.5852C39.1927 40.5852 33.9512 45.8268 33.9512 52.2926C33.9512 58.7584 39.1927 64 45.6585 64Z",
    fill: "#FF7272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.776 42.3096C52.8693 44.0899 53.5002 46.1847 53.5002 48.4271C53.5002 54.8928 48.2587 60.1344 41.7928 60.1344C39.5504 60.1344 37.4557 59.5036 35.6753 58.4103C37.7345 61.7634 41.4352 64.0001 45.6585 64.0001C52.1243 64.0001 57.3659 58.7586 57.3659 52.2927C57.3659 48.0693 55.1292 44.3687 51.776 42.3096Z",
    fill: "#FF3636"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3091 40.0015C30.3091 37.7025 28.4455 35.8389 26.1465 35.8389C23.8475 35.8389 21.9839 37.7025 21.9839 40.0015C21.9839 41.542 22.8214 42.886 24.0651 43.6059V51.0555C24.0651 52.205 24.997 53.1367 26.1464 53.1367C27.2959 53.1367 28.2276 52.2049 28.2276 51.0555V43.6059C29.4716 42.886 30.3091 41.542 30.3091 40.0015Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6589 56.9156C45.141 56.9156 44.7214 56.4958 44.7214 55.9781V52.9418C44.7214 52.424 45.141 52.0043 45.6589 52.0043C46.5472 52.0043 47.374 51.6489 47.9866 51.0037C48.5989 50.3588 48.9107 49.513 48.8644 48.6222C48.7779 46.9527 47.399 45.6186 45.7255 45.5848C44.1035 45.5538 42.7037 46.7388 42.4796 48.3453C42.4591 48.4923 42.4487 48.6434 42.4487 48.7942C42.4487 49.3119 42.0291 49.7317 41.5112 49.7317C40.9934 49.7317 40.5737 49.3119 40.5737 48.7942C40.5737 48.557 40.5902 48.3188 40.6227 48.0862C40.9782 45.5394 43.1881 43.6609 45.7634 43.7102C48.415 43.7635 50.5996 45.8786 50.737 48.5251C50.8101 49.9344 50.3162 51.2732 49.3464 52.2947C48.5956 53.0854 47.6417 53.6012 46.5964 53.7942V55.9782C46.5964 56.4958 46.1766 56.9156 45.6589 56.9156Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6587 60.8762C46.1765 60.8762 46.5962 60.4565 46.5962 59.9387C46.5962 59.421 46.1765 59.0012 45.6587 59.0012C45.1409 59.0012 44.7212 59.421 44.7212 59.9387C44.7212 60.4565 45.1409 60.8762 45.6587 60.8762Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassword);
export default __webpack_public_path__ + "static/media/forgotPassword.2387c169a16b0c2f478ce098b35546a3.svg";
export { ForwardRef as ReactComponent };